webpackJsonp([10],{

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

// process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');
var mc = __webpack_require__(0);
mc.runVue(['Slider', 'Navigation', 'slickSlider', 'selectList']);
mc.runComponents(['rating']);
mc.runFooter();
var counter = __webpack_require__(8);
counter.init();

$('body').on('ajaxResponse', function () {
	mc.runVue(['selectList']);
});

/***/ })

},[104]);


// WEBPACK FOOTER //
// bundles/product.bundle.js